import React from 'react';
import { Card, Tabs } from 'antd';

const AdminSettings: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card title="Paramètres">
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Général" key="1">
            <p>Paramètres généraux</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Sécurité" key="2">
            <p>Paramètres de sécurité</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Notifications" key="3">
            <p>Paramètres de notifications</p>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default AdminSettings;